import { t } from "ttag";

import type { ExcludeOperatorOption, ExcludeUnitOption } from "./types";

export const EXCLUDE_UNIT_OPTIONS: ExcludeUnitOption[] = [
  {
    unit: "day-of-week",
    label: t`Долоо хоногийн өдрөөр…`,
  },
  {
    unit: "month-of-year",
    label: t`Жилийн сараар…`,
  },
  {
    unit: "quarter-of-year",
    label: t`Жилийн улирлаар…`,
  },
  {
    unit: "hour-of-day",
    label: t`Өдрийн цагаар…`,
  },
];

export const EXCLUDE_OPERATOR_OPTIONS: ExcludeOperatorOption[] = [
  {
    operator: "not-null",
    label: t`Хоосон утга`,
  },
  {
    operator: "is-null",
    label: t`Хоосон биш утга`,
  },
];
